<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Create"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <form-group label="Select Account">
              <v-select
                label="accountable"
                :options="accounts"
                :filterable="false"
                @search="getAccounts"
                v-model="selectedAccount"
              >
                <template slot="no-options">
                  Type to search clients/partners by name or contact number
                </template>
                <template slot="option" slot-scope="c">
                  <div v-if="c.accountable">
                    {{ c.accountable.name }} {{ c.accountable.surname }} - {{ c.accountable.contact_number }}<br />
                    ({{ c.accountable_type.replace('App\\','') }}) - {{ c.accountable.email_address }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="c">
                    <div v-if="c.accountable">
                  {{ c.accountable.name }} {{ c.accountable.surname }}
                  </div>
                </template>
              </v-select>

              <small v-if="$v.selectedAccount.$error" class="text-danger">
                Please select account
              </small>
            </form-group>

            <form-group label="Type" :required="true">
              <b-form-select
                @blur="$v.payment.payment_type_id.$touch"
                :class="{ 'is-invalid': $v.payment.payment_type_id.$error }"
                v-model="payment.payment_type_id"
              >
                <b-form-select-option
                  v-for="pt in paymentTypes"
                  :value="pt.id"
                  :key="pt.id"
                  >{{ pt.type }}</b-form-select-option
                >
              </b-form-select>
              <div
                class="invalid-feedback"
                v-if="!$v.payment.payment_type_id.required"
              >
                Please select payment type
              </div>
            </form-group>

            <form-group label="Reference" :required="true">
              <input
                type="text"
                @blur="$v.payment.reference.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.payment.reference.$error }"
                v-model="payment.reference"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.payment.reference.required"
              >
                Please enter reference
              </div>
            </form-group>

            <form-group label="Amount" :required="true">
              <input
              min="0"
                type="number"
                @blur="$v.payment.transaction_amount.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.payment.transaction_amount.$error }"
                v-model="payment.transaction_amount"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.payment.transaction_amount.required"
              >
                Please enter amount
              </div>
            </form-group>

             <div class="scroller300">
                 <form-group label="Mark as paid">
                    <b-form-checkbox-group
                    v-model="selectedInvoices"
                    :options="unpaidInvoices"
                    value-field="id"
                    html-field="invoice_info"
                    switches
                    stacked
                  > 
                  </b-form-checkbox-group>
                 </form-group>
             </div>
          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import accountRepo from "@/api/repos/accountRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";

export default {
  props: ["accountId"],

  components: {
    formBase,
    formGroup,
  },

  validations: {
    selectedAccount: {
      required,
    },
    payment: {
      account_id: {
        required,
      },
      payment_type_id: {
        required,
      },
      reference: {
        required,
      },
      transaction_amount: {
        required,
      },
    },
  },

  mounted() {
    this.getPaymentTypes();
    if(this.accountId){
      this.accountSearch(this.accountId);      
    }
  },

  data() {
    return {
      selectedInvoices: [],
      unpaidInvoices: [],
      accounts: [],
      selectedAccount: {},
      searchActivated:false,
      paymentTypes: [],
      payment: {},
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
    };
  },

  methods: {
    getAccounts(search) {
      this.searchActivated=true
      if (search.length > 1) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => {
          this.accountSearch(search);
        }, 500);
      }
    },

    async accountSearch(search) {
      try {
        let { data } = await accountRepo.accounts(
          1,
          25,
          "id",
          "asc",
          search,
          null
        );
        this.accounts = data.accounts.data;
        if(this.accountId && !this.searchActivated){
          this.accounts.forEach(a => {
            if(a.id == this.accountId){
              this.selectedAccount = a;
            }
          })
        }
      } finally {
        this.loading = false;
      }
    },
    async getPaymentTypes() {
      let { data } = await accountRepo.paymentTypes();
      this.paymentTypes = data.payment_types;
    },
    
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";

      this.payment.account_id = this.selectedAccount.id
      this.payment.invoices = this.selectedInvoices
     
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          
        await accountRepo.paymentCreate(this.payment);
         
         this.$root.$bvToast.toast("Success", {
            title: "Payment Addedd",
            autoHideDelay: 3000,
            variant: "success",
          });

        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.$v.$reset()
          this.payment = {};
          this.selectedAccount = null;
          this.loading = false;
          this.submitStatus = null;
          if(this.accountId){
            this.accountSearch(this.accountId);      
          }
        }
      }
    },

    async getInvoices(){
       let { data } = await accountRepo.accountInvoices(
          this.selectedAccount.id,
          1,
          1000,
          'invoice_number',
          'asc',
          '',
          `{"filters":[{"column":"is_paid","value":0,"label":"Not Paid"}]}`
        );

        this.unpaidInvoices = data.invoices.data;
        this.unpaidInvoices.forEach(i => {
          if(i.job){
            i.invoice_info = `#${i.invoice_number} - ${i.total_amount} - Job#${i.job.job_number}`
          }else{
            i.invoice_info = `#${i.invoice_number} - ${i.total_amount}`
          }
          
        })
    }
  },

  watch: {
    selectedAccount: function (val) {
      if(val){
        this.getInvoices()
      }
    },   
  }

};
</script>

<style></style>
